import { Card, CardBody, HStack, Heading, Skeleton, Stack, Text } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';

import { routes } from '@blockpulse3/data/shared';
import { useGetSpvDraftQuery } from '@blockpulse3/graphql/hooks';
import { CompanyIdentityAvatar, ErrorQueryCard } from '@blockpulse3/ui/commons';

type Props = unknown;

/**
 * SPVHeader.
 *
 * @returns {JSX.Element}
 */
export function SPVHeader(): JSX.Element {
  const { id = '' } = useParams();
  const navigate = useNavigate();

  const { data, loading, error } = useGetSpvDraftQuery({ variables: { id } });

  if (data?.spvDraft && data?.spvDraft.deletedAt) {
    navigate(routes.workspace.fmt(data?.spvDraft.company.id));
  }

  if (loading) {
    return (
      <Skeleton>
        <Card h="150px" />
      </Skeleton>
    );
  }

  if (error) {
    return <ErrorQueryCard h="150px" />;
  }

  if (!data) {
    return <ErrorQueryCard h="150px" />;
  }

  const { content } = data.spvDraft;

  return (
    <Card>
      <HStack as={CardBody} spacing="8">
        <CompanyIdentityAvatar boxSize="40" />
        <Stack spacing="3">
          <Text color="gray.500" fontSize="xs" fontWeight="semibold">
            IMMATRICULATION
          </Text>
          <Heading fontWeight="bold">{content.name}</Heading>
        </Stack>
      </HStack>
    </Card>
  );
}

export type SPVHeaderProps = Props;
